import { useLocation } from '@reach/router'

// for (const param of searchParams) { console.log(param) }
export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(useLocation().search)
}
